import { useCallback, useContext, useMemo } from 'react'

import { SelectedCoinsContext, SetInputLoadingStateAction } from '../stateManagement'

const useCoinInputLoadingSetter = ({
    dispatchSelectedCoins: dispatchSelectedCoinsProvided,
}: {
    dispatchSelectedCoins?: (action: object) => void
} = {}) => {
    const {
        state: {
            from: { isLoading: isFromLoadingState },
            to: { isLoading: isToLoadingState },
        },
        dispatchAction: dispatchSelectedCoinsInjected,
    } = useContext(SelectedCoinsContext)

    const dispatchSelectedCoins = useMemo(
        () => dispatchSelectedCoinsProvided || dispatchSelectedCoinsInjected,
        [dispatchSelectedCoinsInjected, dispatchSelectedCoinsProvided],
    )

    return useCallback(
        (
            loadingState:
                | boolean
                | {
                      isFromInputLoading: boolean
                      isToInputLoading: boolean
                  },
        ): void => {
            const { isFromInputLoading = isFromLoadingState, isToInputLoading = isToLoadingState } =
                loadingState === true || loadingState === false
                    ? {
                          isFromInputLoading: loadingState,
                          isToInputLoading: loadingState,
                      }
                    : loadingState

            dispatchSelectedCoins(
                new SetInputLoadingStateAction({
                    isFromCoinInputLoading: isFromInputLoading,
                    isToCoinInputLoading: isToInputLoading,
                }),
            )
        },
        [dispatchSelectedCoins, isFromLoadingState, isToLoadingState],
    )
}

export { useCoinInputLoadingSetter }
